import STREAMED_LIST_REQUEST_CONFIG from '@client-shared/api/streamed-list-request-config.js'
import Activity from '@client-shared/models/activity.model.js'
import { getResponseData } from '@client-shared/utils/get-response-data.js'

export const postActivitiesQuery = async ({ axios, projectId, query }) => {
  const response = await axios.post('activities', {
    projectId,
    ...query,
  }, STREAMED_LIST_REQUEST_CONFIG)

  const data = getResponseData(response)

  if (!Array.isArray(data)) { return [] }

  return data.map(a => new Activity(a))
}

export const getActivity = async ({ axios, projectId, activityId, signal }) => {
  const { data } = await axios.get(`activities/${activityId}`, {
    signal,
    params: {
      projectid: projectId,
    },
  })

  return new Activity(data)
}
